// src/auth/screens/PasswordResetScreen.jsx — route /password-reset?token=…
//
// ⚠️ THIS PATH IS BACKEND CONFIGURATION: `password_reset_url` in
// context-library/product/transactional-email.yaml (template
// "<base>/password-reset?token=$token"). Renaming this route requires the same
// change on every backend deployment, or every recovery mail 404s.
import React from 'react';
import TokenPasswordScreen from './TokenPasswordScreen.jsx';

export default function PasswordResetScreen() {
  return <TokenPasswordScreen variant="reset" />;
}
